import { Card, Rate, Tooltip } from "antd";
import ComaIcon from "../../assets/icons/ComaIcon";

type Props = {
  img: string;
  text: string;
  name: string;
  role?: string;
  rating: number;
};

export default function ReviewItem({ img, text, name, role, rating }: Props) {
  return (
    <Card
      className="rounded-xl border-none shadow-lg w-full"
      bodyStyle={{
        padding: 24,
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <ComaIcon className="!text-5xl" />

      {/* Review text */}
      <p className="text-slate-600 text-base font-normal mt-2 mb-6 line-clamp-2 flex-grow min-h-[45px]">
        {text ? `"${text}"` : ""}
      </p>

      <div className="flex items-center justify-between mt-auto">
        <div className="flex items-center gap-3 min-w-0">
          <img
            src={img}
            className="w-12 h-12 rounded-full object-cover flex-shrink-0"
          />
          <div className="min-w-0">
            <Tooltip title={name}>
              <p className="text-theme-zinc-700 text-xl font-medium truncate">
                {name}
              </p>
            </Tooltip>
            {!!role && (
              <p className="text-theme-slate-500 text-base font-normal truncate">
                {role}
              </p>
            )}
          </div>
        </div>

        <div className="flex items-center gap-1 flex-shrink-0">
          <Rate
            className="custom-rate"
            allowHalf
            disabled
            defaultValue={rating}
            count={1}
            style={{ fontSize: 18 }}
          />
          <span className="justify-start text-theme-slate-600 text-sm font-normal mt-1">
            {rating}/5
          </span>
        </div>
      </div>
    </Card>
  );
}
